import '@site/styles/sass/styles.scss';

import $ from 'jquery';
import 'jquery-migrate';
import './vendor/jquery-ui.min.js';
import './vendor/jquery.uploadifive.min.js';
import 'jquery-validation';
import { addClass, removeClass, toggleClass, hasClass, siblings, children, createCookie, readCookie, transEndEventName } from './plugins.js';
import './vendor/niceSelect.js';
import 'slick-carousel';
import './vendor/swishCarousel.js';
import Isotope from 'isotope-layout';
import jQueryBridget from 'jquery-bridget';

window.$ = window.jQuery = $;
jQueryBridget('isotope', Isotope, $ );

$(document).ready(function(){
	var _window = $(window);

	$('.js-confirm-check')
		.on('click', function(event){
			if($(this).is(':checked')) {
				$('.button').prop('disabled',false);
			} else {
				$('.button').prop('disabled',true);
			}
		});

	$('.js-confirm-redirect')
		.on('click', function(event){
			if(!$(this).is(':disabled')) {
				window.location.href = 'https://www.dorset.pcc.police.uk/'+$(this).data('redirect');
			}
		});

	// ---------------------
	// Contact form selector
	// ---------------------
	if(typeof contact !== 'undefined') {
		var _main = '';
		$.each(Object.keys(contact), function(k, v) {
			var mainItem = contact[v];
			_main += '<option value="'+mainItem.id+'">'+mainItem.pagetitle+'</option>';
		});
		$('.js-contact-main').append(_main);

		$('.js-contact-main').change(function() {
			if(!this.value) {
				$('.contact-process.child').hide();

				$('.js-contact-child').html('<option value="">Please select</option>');
				$('.js-contact-info').html('');
				return;
			}
			var _myId = this.value,
				_children = contact[_myId]["children"],
				_child = '';
			$.each(Object.keys(_children), function(k, v) {
				var childItem = _children[v];
				_child += '<option value="'+_myId+'-'+childItem.id+'">'+childItem.pagetitle+'</option>';
			});

			$('.contact-process.child').slideDown();
			$('.js-contact-info').slideUp();
			$('.js-contact-child').html('<option value="" selected="selected">Please select</option>'+_child).trigger('nschange');
		});

		$('.js-contact-child').change(function() {
			if(!this.value) {
				$('.js-contact-info').html('');
				return;
			}
			var ids = this.value.split('-');

			$('.js-contact-info').slideDown();
			$('.js-contact-info .inner').html(contact[ids[0]]["children"][ids[1]].content);
		});
	}
	$('.js-form-spam')
		.each(function(index, elForm){
			elForm.action = elForm.getAttribute('data-action');
		});

	// ---
	// Nav
	// ---
	// Navigate when nav select is changed (for mobile)
	$('.nav-select').on('change', 'select', function(){
		if (this.value !== '')
			window.location = this.value;
    });

	$('.js-mobilenav')
		.on('click', function(event){
            if (window.document.body.classList.contains('mobilenav__open')) {
                window.document.body.classList.remove('mobilenav__open');

				const linksEls = document.querySelectorAll(
                    '.skip-section a, header .logo, header .mobilenav_button, header .nav-main a, header .information a, header .right a, main a, main button, main input, footer a, footer button, footer input'
                );
                linksEls.forEach((el) => (el.tabIndex = '0'));
            } else {
                window.document.body.classList.add('mobilenav__open');

				const linksEls = document.querySelectorAll(
                    '.skip-section a, header .logo, header .mobilenav_button, header .nav-main a, header .information a, header .right a, main a, main button, main input, footer a, footer button, footer input'
                );
				linksEls.forEach((el) => el.tabIndex = '-1' );
            }
        });

    $('.js-nav-mobile')
		.on('click', '.parent', function(e){
			e.preventDefault();

            $(this).next('.nav-level1-container').css({ 'display': 'flex', left: $(window).width() });
            $(this).next('.nav-level1-container').animate({ left: '0' }, 'fast');
        })
        .on('click', '.level1-back-btn', function(e) {
            e.preventDefault();
            $(this).closest('.nav-level1-container').animate({ left: -$(window).width() }, 'fast');
            e.stopPropagation();
        })
		.on('click', '.level2-parent', function(e) {
            if ($(this).next('.nav-level2-container').length) {
                e.preventDefault();

                $(this).next('.nav-level2-container').css({ 'display': 'flex', left: $(window).width() });
                $(this).next('.nav-level2-container').animate({ left: '0' }, 'fast');
            }
        })
        .on('click', '.level2-back-btn', function(e) {
            e.preventDefault();
            $(this).closest('.nav-level2-container').animate({ left: -$(window).width() }, 'fast');
            e.stopPropagation();
        })
		.on('click', '.level3-parent', function(e) {
            if ($(this).next('.nav-level3-container').length) {
                e.preventDefault();

                $(this).next('.nav-level3-container').css({ 'display': 'flex', left: $(window).width() });
                $(this).next('.nav-level3-container').animate({ left: '0' }, 'fast');
            }
        })
        .on('click', '.level3-back-btn', function(e) {
            e.preventDefault();
            $(this).closest('.nav-level3-container').animate({ left: -$(window).width() }, 'fast');
            e.stopPropagation();
        })
		.on('click', 'ul, li, a', function(event){
			event.stopPropagation();
		});

	// Track Tab key usage to prevent submenu opening when tabbing
	var isTabNavigation = false;
	var lastFocusedElement = null;
	$(document).on('keydown', function(e) {
		if (e.key === 'Tab' || e.keyCode === 9) {
			isTabNavigation = true;
			lastFocusedElement = document.activeElement;
			// Mark all nav links to prevent submenu opening on next focus
			$('.nav-main > ul > li > a').data('tab-nav', true);
			setTimeout(function() {
				isTabNavigation = false;
			}, 500);
		} else {
			// Clear tab-nav flag when other keys are pressed (like Enter)
			if (e.key === 'Enter' || e.keyCode === 13) {
				$('.nav-main > ul > li > a').removeData('tab-nav');
			}
		}
	});

	$('.nav-main')
		.each(function(index, elNav){
			var id = this.getAttribute('data-page');
			var elActive = this.querySelector('[data-menu="'+id+'"]');

			$(elActive)
				.addClass('active')
				.parents('li')
					.addClass('active');
		});

	$('.nav-main > ul > li')
		.each(function(index, el){
            $(this).children('a').on('focus', function(e) {
                e.preventDefault();

                var $parent = $(this).parent();
                var $this = $(this);
                
                var previousWasOutsideNav = lastFocusedElement && 
                                           $(lastFocusedElement).closest('.nav-main').length === 0;
                var cameFromTab = isTabNavigation || 
                                 $this.data('tab-nav') || 
                                 previousWasOutsideNav;
                
                if ($parent.hasClass('has-submenu') && 
                    !$this.data('keyboard-nav') && 
                    !cameFromTab) {
                    $parent.addClass('open');
                }
                $this.removeData('keyboard-nav');
                $this.removeData('tab-nav');
                lastFocusedElement = this;
            });

            $(this).children('a').on('blur', function(e) {
                e.preventDefault();

                var $parent = $(this).parent();
                setTimeout(function() {
                    if ($parent.hasClass('has-submenu') && $parent.hasClass('open') && $parent.find('a:focus').length == 0) {
                        $parent.removeClass('open');
                    }
                }, 1);
            });

            $(this).children('a').on('keydown', function(e) {
                if (e.key === 'Escape' || e.keyCode === 27) {
                    var $parent = $(this).parent();
                    if ($parent.hasClass('has-submenu') && $parent.hasClass('open')) {
                        e.preventDefault();
                        $parent.removeClass('open');
                        $(this).data('keyboard-nav', true);
                        $(this).focus();
                    }
                } else if (e.key === 'ArrowRight' || e.keyCode === 39) {
                    e.preventDefault();
                    var $parent = $(this).parent();
                    if ($parent.hasClass('has-submenu') && $parent.hasClass('open')) {
                        $parent.removeClass('open');
                    }
                    var $nextNav = $parent.next('li').children('a');
                    if ($nextNav.length > 0) {
                        $nextNav.data('keyboard-nav', true);
                        $nextNav.focus();
                    }
                } else if (e.key === 'ArrowLeft' || e.keyCode === 37) {
                    e.preventDefault();
                    var $parent = $(this).parent();
                    if ($parent.hasClass('has-submenu') && $parent.hasClass('open')) {
                        $parent.removeClass('open');
                    }
                    var $prevNav = $parent.prev('li').children('a');
                    if ($prevNav.length > 0) {
                        $prevNav.data('keyboard-nav', true);
                        $prevNav.focus();
                    }
                } else if (e.key === 'Enter' || e.keyCode === 13) {
                    var $parent = $(this).parent();
                    if ($parent.hasClass('has-submenu')) {
                        e.preventDefault();
                        $(this).removeData('tab-nav');
                        $parent.addClass('open');
                        var $firstSubmenuLink = $parent.children('.nav-dropdown').find('a').first();
                        if ($firstSubmenuLink.length > 0) {
                            $firstSubmenuLink.focus();
                        }
                    }
                } else if (e.key === 'Tab' || e.keyCode === 9) {
                    var $parent = $(this).parent();
                    if ($parent.hasClass('has-submenu')) {
                        if ($parent.hasClass('open')) {
                            if (!e.shiftKey) {
                                e.preventDefault();
                                var $firstSubmenuLink = $parent.children('.nav-dropdown').find('a').first();
                                if ($firstSubmenuLink.length > 0) {
                                    $firstSubmenuLink.focus();
                                }
                            }
                        } else {
                            if (!e.shiftKey) {
                                e.preventDefault();
                                var $nextNav = $parent.next('li').children('a');
                                if ($nextNav.length > 0) {
                                    $nextNav.data('keyboard-nav', true);
                                    $nextNav.data('tab-nav', true);
                                    $nextNav.focus();
                                } else {
                                    return true;
                                }
                            } else {
                                e.preventDefault();
                                var $prevNav = $parent.prev('li').children('a');
                                if ($prevNav.length > 0) {
                                    $prevNav.data('keyboard-nav', true);
                                    $prevNav.data('tab-nav', true);
                                    $prevNav.focus();
                                } else {
                                    return true;
                                }
                            }
                        }
                    }
                }
            });

            $(this).children('.nav-dropdown').find('a').on('blur', function(e) {
                e.preventDefault();

                var $parent = $(this).closest('.nav-dropdown').parent();
                setTimeout(function() {
                    if ($parent.hasClass('has-submenu') && $parent.hasClass('open') && $parent.find('a:focus').length == 0) {
                        $parent.removeClass('open');
                    }
                }, 1);
            });

            $(this).children('.nav-dropdown').find('a').on('keydown', function(e) {
                if (e.key === 'Escape' || e.keyCode === 27) {
                    var $parent = $(this).closest('.nav-dropdown').parent();
                    if ($parent.hasClass('has-submenu') && $parent.hasClass('open')) {
                        e.preventDefault();
                        $parent.removeClass('open');
                        var $parentLink = $parent.children('a');
                        $parentLink.data('keyboard-nav', true);
                        $parentLink.focus();
                    }
                } else if (e.key === 'Tab' || e.keyCode === 9) {
                    var $parent = $(this).closest('.nav-dropdown').parent();
                    var $allSubmenuLinks = $parent.children('.nav-dropdown').find('a');
                    var currentIndex = $allSubmenuLinks.index(this);
                    
                    if (!e.shiftKey) {
                        if (currentIndex < $allSubmenuLinks.length - 1) {
                            e.preventDefault();
                            $allSubmenuLinks.eq(currentIndex + 1).focus();
                        } else {
                            e.preventDefault();
                            var $nextNav = $parent.next('li').children('a');
                            if ($nextNav.length > 0) {
                                $nextNav.data('keyboard-nav', true);
                                $nextNav.focus();
                            } else {
                                return true;
                            }
                        }
                    } else {
                        if (currentIndex > 0) {
                            e.preventDefault();
                            $allSubmenuLinks.eq(currentIndex - 1).focus();
                        } else {
                            e.preventDefault();
                            var $parentLink = $parent.children('a');
                            $parentLink.data('keyboard-nav', true);
                            $parentLink.focus();
                        }
                    }
                }
            });
		});

	// Automatically set links with a different domain to open in a new window
	$('[href^=http]').each(function(index, element) {
		try {
			if (this.href && this.href.indexOf(window.location.hostname) < 0) {
				this.target = '_blank';
			}
		}
		catch(e) {
			this.href = '';
		}
	});


	// -----------
	// Nice Select
	// -----------
	$('.js-nice-select').niceSelect();


	// --------------
	// External Links
	// --------------
	$('[rel=external]').attr('target', '_blank');
	$('[rel=new_window]').attr('target', '_blank');


	// --------------
	// Highlight Tags
	// --------------
	$('.js-tag-highlight').each(function(index ,el){
		var links = el.querySelectorAll('a'),
			q = _ad.qString(window.location.search),
			key = $(this).data('key');

		if (!q) { // Jump out the function if there are no url params
			return false;
		}

		for (var i = 0; i < links.length; i++) {
			var linkQ = _ad.qString(links[i].href),
				a = true;

			if (linkQ !== false) {
				if(linkQ[key] == '') break;
				if ((key in q) && linkQ[key] == q[key]) {
					$(links[i]).parent().addClass('active').parent().addClass('tag-active');
					a = false;
					break;
				}

				if (!a) {
					break;
				}
			}
		}
	});


	// ---------------
	// Location Select
	// ---------------
	$('.js-select-location')
		.on('change', function(event){
			createCookie('location', this.value, 1);
			window.location = window.location.href;
		});
	$('.js-select-loc')
		.on('change', function(event) {
			$(this).parents('form').submit();
		});


	// -----
	// Diary
	// -----
	$('.js-diary-entry')
		.on('click', function(event){
			event.preventDefault();

			var _diaryDetails = this.nextElementSibling || nextElementSibling(this),
				_diaryDetailsInner = _diaryDetails.querySelector('.inner'),
				cssHeight = 0;

			toggleClass(this, 'open');
			if (hasClass(this, 'open')) {
				cssHeight = _diaryDetailsInner.offsetHeight;
			}

			_diaryDetails.style.height = cssHeight + 'px';
		});

	$('.js-diary-close')
		.on('click', function(event){
			event.preventDefault();

			var _li = $(this).parents('li'),
				_h3 = _li.children('.js-diary-entry');

			_h3.click();
		});


	// -------------
	// Select Filter
	// -------------
	$('.js-select-filter')
		.on('change', function(){
			var qs = _ad.qString(window.location.search);

			delete qs["arc_day"]; // Remove the day filter option //

			if (this.value !== '') {
				if(this.value.indexOf('/') > -1) {
					var parts = this.value.split('/');
					qs["article_month"] = parts[parts.length-1];
					qs["article_year"] = parts[parts.length-2];
				} else {
					var parts = this.value.split('-');
					qs["arc_month"] = parts[parts.length-1];
					qs["arc_year"] = parts[parts.length-2];
				}
			} else {
				delete qs["arc_month"];
				delete qs["arc_year"];
				delete qs["article_month"];
				delete qs["article_year"];
			}
			window.location = window.location.pathname+'?'+serialize(qs);
		});
	var qs = _ad.qString(window.location.search);
	if(qs["article_month"] && qs["article_year"]) {
		var value = qs["article_year"]+'/'+qs["article_month"];
		$('.js-select-filter option[value$="'+value+'"]').attr('selected',true)
		$('.js-select-filter').trigger('nschange');
	}
	if(qs["arc_month"] && qs["arc_year"]) {
		var value = qs["arc_year"]+'-'+qs["arc_month"];
		$('.js-select-filter option[value$="'+value+'"]').attr('selected',true)
		$('.js-select-filter').trigger('nschange');
	}

	$('.js-filter-options')
		.each(function(index, elFilterOpts){
			var elFilters = elFilterOpts.querySelectorAll('select');
			var options = _ad.qString(window.location.search) || {};

			$(elFilterOpts)
				.on('change', function(){
					for (var i = 0, l = elFilters.length; i < l; i++) {
						options[elFilters[i].name] = elFilters[i].value;
					}
					var optionsArr = [];
					for (var opt in options) {
						optionsArr.push(opt + '=' + options[opt]);
					}
					window.location = window.location.protocol + '//' + window.location.hostname + window.location.pathname + '?' + optionsArr.join('&');
				});
		});


	// ----------------
	// Articles Filters
	// ----------------
	// $('.articles-filter')
	// 	.each(function(index, elFilters){
	// 		var _filters = $(elFilters);

	// 		_filters
	// 			.on('click', 'a', function(){
	// 				_filters.addClass('loading');
	// 			})
	// 			.on('change', 'select', function(){
	// 				_filters.addClass('loading');
	// 			});
	// 	});


	// ---
	// Nav
	// ---
	var _navMain = document.querySelector('.nav-main'),
		navMainWidth = _navMain.offsetWidth;
	$('.nav-main > ul > li')
		.each(function(index, el){
			var _navDrop = el.querySelector('.nav-dropdown'),
				navDropWidth = _navDrop.offsetWidth;

			navMainWidth = _navMain.offsetWidth;

			if ((el.offsetLeft + navDropWidth) > navMainWidth) {
				addClass(_navDrop, 'align-right');
			}



		});

	// ----------
	// Transcript
	// ----------

	$('.js-transcript-toggle')
		.on('click', function(event){
			event.preventDefault();

			var _transcript = this.nextElementSibling || nextElementSibling(this),
				_transcriptInner = _transcript.querySelector('.inner'),
				cssHeight = 0;

			toggleClass(this, 'open');
			if (hasClass(this, 'open')) {
				cssHeight = _transcriptInner.offsetHeight;
			}

			_transcript.style.height = cssHeight + 'px';
		});

	$('.js-popup-open-parent')
		.on('click', '.js-transcript-toggle', function(event){
			event.preventDefault();

			var _transcript = this.nextElementSibling || nextElementSibling(this),
				_transcriptInner = _transcript.querySelector('.inner'),
				cssHeight = 0;

			toggleClass(this, 'open');
			if (hasClass(this, 'open')) {
				cssHeight = _transcriptInner.offsetHeight;
			}

			_transcript.style.height = cssHeight + 'px';
		});


	// --------------
	// Slick Carousel
	// --------------
	// $('.js-slick-carousel').slick({
	// 	dots: true,
	// 	infinite: false,
	// 	speed: 300,
	// 	slidesToShow: 4,
	// 	slidesToScroll: 4,
	// 	responsive: [{
	// 		breakpoint: 1024,
	// 		settings: {
	// 			slidesToShow: 3,
	// 			slidesToScroll: 3,
	// 			infinite: true,
	// 			dots: true
	// 		}
	// 	}, {
	// 		breakpoint: 600,
	// 		settings: {
	// 			slidesToShow: 2,
	// 			slidesToScroll: 2
	// 		}
	// 	}, {
	// 		breakpoint: 480,
	// 		settings: {
	// 			slidesToShow: 1,
	// 			slidesToScroll: 1
	// 		}
	// 	}]
	// });

	$('.js-slick-carousel').slick({
		arrows: true,
		dots: false,
		fade: true,
		infinite: true,
		autoplay: false,
		autoplaySpeed: 5000,
		speed: 300,
		slidesToShow: 1,
		slidesToScroll: 1
	});

	$('.js-slick-fade').slick({
        arrows: false,
        autoplay: false,
        autoplaySpeed: 5000,
        dots: false,
        fade: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
    });

	$('.js-slick-slider').slick({
        autoplay: false,
        autoplaySpeed: 5000,
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    });

	$('.js-slick-slider-narrow').slick({
        autoplay: false,
        autoplaySpeed: 5000,
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
    });

	$('.js-slick-grants-wide').slick({
        autoplay: false,
        autoplaySpeed: 5000,
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 599,
                settings: {
                    slidesToShow: 1,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow: 3,
                },
            },
        ],
    });

	$('.js-slick-grants-thin').slick({
        autoplay: false,
        autoplaySpeed: 5000,
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 599,
                settings: {
                    slidesToShow: 1,
                },
            },
            {
                breakpoint: 959,
                settings: {
                    slidesToShow: 2,
                },
            },
        ],
    });


	// --------------
	// Swish Carousel
	// --------------
	$('.js-swish-carousel').swishCarousel();


	// --------
	// Timeline
	// --------
	$('.js-timeline')
		.on('click', '[data-month]', function(){
			var _link = $(this),
				lblMonth = $('.js-timeline h2 .month');

			lblMonth.text(_link.data('month'));
		});



	// ----
	// Tabs
	// ----
	$('.js-tabs').each(function(index, el){
		var mq = {},
			tabs = el,
			links = tabs.querySelectorAll('.js-tabs-links a'),
			_links = $(links),
			subsequentClick = false;

		if (window.matchMedia) {
			mq = window.matchMedia( "(max-width: 767px)" );
		} else {
			mq.matches = false;
		}

		_links
			.on('click', function(ev){
				ev.preventDefault();

				var tab = document.querySelector(this.href.substr(this.href.indexOf('#'))),
					sibl = tab.parentNode.children;

				// Show Tab Content
				for (var i = 0; i < sibl.length; i++) {
					if (sibl[i] !== tab)
						removeClass(sibl[i], 'show');
				}
				addClass(tab, 'show');

				// Highlight Tab Link
				for (var i = 0; i < links.length; i++) {
					if (links[i] !== tab)
						removeClass(links[i], 'active');
				}
				addClass(this, 'active');

				if (mq.matches && subsequentClick) {
					// scroll to the top of the tabs to highlight //
					var rect = tabs.getBoundingClientRect();
					$('html, body')
						.animate({ scrollTop: rect.top + _ad.window.scrollTop() });
				}

				subsequentClick = true;
			})
			.each(function(){})
			.first()
			.click();

		_ad.checkHeight(_links, false, false);
		_window.on('resize', function(){
			//_ad.checkHeight(_links);
		});
	});


	// -----------
	// Infographic
	// -----------
	$('.ig')
		.each(function(index, element){
			// var radius = (element.offsetWidth / 2); // radius of the circle

			// radius = 400;

			// var fields = $('.bubble'),
			// 	container = $(element),
			// 	width = container.width(),
			// 	height = container.height(),
			// 	angle = 90,
			// 	step = (2*Math.PI) / fields.length;
			// 	fields.each(function() {
			// 		var x = Math.round(width/2 + radius * Math.cos(angle) - $(this).width()/2),
			// 			y = Math.round(height/2 + radius * Math.sin(angle) - $(this).height()/2);
			// 		$(this).css({
			// 			left: x + 'px',
			// 			top: y + 'px'
			// 		});
			// 		angle += step;
			// 	});
		})
		.on('click', '.bubble', function(event){
			var _sibl = siblings(this);

			removeClass(this, 'fade');

			if (hasClass(this, 'active')) {
				for (var i = 0; i < _sibl.length; i++) {
					if (hasClass(_sibl[i], 'bubble')) {
						removeClass(_sibl[i], 'fade');
					}

					if (hasClass(_sibl[i], 'bubble-content')) {
						removeClass(_sibl[i], 'show');

						if (Modernizr.csstransitions !== true) {
							addClass(_sibl[i], 'hide');
						}
					}
				}

				removeClass(this, 'active');
			} else {
				for (var i = 0; i < _sibl.length; i++) {
					if (hasClass(_sibl[i], 'bubble')) {
						addClass(_sibl[i], 'fade');
						removeClass(_sibl[i], 'active');
					}

					if (hasClass(_sibl[i], 'bubble-content')) {
						removeClass(_sibl[i], 'show');

						if (Modernizr.csstransitions !== true) {
							addClass(_sibl[i], 'hide');
						}
					}
				}

				var _content = document.querySelector(this.href.substr(this.href.indexOf('#')));

				removeClass(_content, 'hide');

				setTimeout(function(){
					addClass(_content, 'show');
				}, 0);

				addClass(this, 'active');
			}
		})
		.on('click', '.js-bubble-close', function(event){
			event.preventDefault();

			var _cont = this.parentNode.parentNode,
				_bubbles = document.querySelectorAll('.bubble');

			removeClass(_cont, 'show');

			if (Modernizr.csstransitions !== true) {
				addClass(_cont, 'hide');
			}

			for (var i = 0; i < _bubbles.length; i++) {
				removeClass(_bubbles[i], 'fade');
				removeClass(_bubbles[i], 'active');
			}
		})
		.on(transEndEventName, '.bubble-content', function(){
			if (!hasClass(this, 'show')) {
				addClass(this, 'hide');
			}
		});



	// ---------------
	// Form Validation
	// ---------------
	// http://jqueryvalidation.org/validate
	$('.js-form-validate').each(function(index, element){
		var _form = $(element);

		_form.validate({
			errorContainer: element.querySelector('.js-error-container'),
			errorLabelContainer: element.querySelector('.js-error-container'),
			wrapper: 'div'
		});

		/*
			rules : {
				"emailconfirm": {
					equalTo: "#email"
				}s
			},
			messages: {
				"emailconfirm": {
					equalTo: 'Please confirm your email address'
				}
			},
		*/
	});


	$('.form-formz')
		.each(function(index, element){
			var _form = $(element),
				_required = _form.find('.required input');

			_required
				.attr('required', 'required');

			_form.validate({
				errorContainer: element.querySelector('.js-error-container'),
				errorLabelContainer: element.querySelector('.js-error-container'),
				wrapper: 'div'
			});
		});


	// -------
	// Cookies
	// -------
	// Policy Cookies
	// if (readCookie('policy') !== 'accepted') {
	// 	var _cookie = $('.cookie'),
	// 		_inner = _cookie.find('.inner');

	// 	_cookie
	// 		.removeClass('hide');

	// 	_cookie.height(_inner.outerHeight());

	// 	$('.js-accept-cookies')
	// 		.on('click', function(){
	// 			createCookie('policy', 'accepted', 365);
	// 			_cookie
	// 				.height(0);
	// 		});
	// } else {
	// 	createCookie('policy', 'accepted', 365);
	// }

	// Newsletter Cookies
	if (readCookie('newsletter') !== 'block') {
		if (readCookie('newsletter') !== 'timer') {
			(function(){
				Date.now = Date.now || function() { return +new Date; };
				createCookie('newsletter', 'timer', 1);
				createCookie('newsletter-timer', Date.now(), 1);
			})()
		}

		var nlTimer = setInterval(function(){
			Date.now = Date.now || function() { return +new Date; };
			if ((Date.now() - readCookie('newsletter-timer')) > 60000) {
				$('.overlay-newsletter')
					.trigger('open');
				createCookie('newsletter-timer', 0, -1);
				createCookie('newsletter', 'block', 365);
				clearInterval(nlTimer);
			}
		},500);
	} else {
		createCookie('newsletter', 'block', 365);
	}


	// ------
	// Popups
	// ------
	var _jsOverlay = $('.js-overlay'),
		_jsOverlayBox = $('.js-overlay-box'),
		_jsCurrentPopup;

	_jsOverlayBox
		.on('open', function(){
			var _overlayBox = $(this);

			_jsCurrentPopup = _overlayBox;

			_overlayBox
				.removeClass('hide');

			setTimeout(function(){
				var topPos = 0;

				topPos = (_window.scrollTop() + (_window.height() / 2)) - (_overlayBox.outerHeight() / 2);

				_overlayBox
					.css({
						top: topPos
					})
					.addClass('show');
			}, 0);

			// Open the overlay background //
			_jsOverlay
				.trigger('open');
		})
		.on('close', function(){
			var _overlayBox = $(this);

			_overlayBox
				.removeClass('show');
		})
		.on(transEndEventName, function(){
			var _overlayBox = $(this);

			if (!_overlayBox.hasClass('show')) {
				_overlayBox
					.addClass('hide');
			}

		});

	_jsOverlay
		.on('open', function(){
			var _overlay = $(this);

			_overlay
				.removeClass('hide');

			setTimeout(function(){
				_overlay
					.addClass('show');
			}, 0);
		})
		.on('close', function(){
			var _overlay = $(this);

			_overlay
				.removeClass('show');


			// Close all popups when the background closes //
			_jsOverlayBox
				.trigger('close');
		})
		.on(transEndEventName, function(){
			var _overlay = $(this);

			if (!_overlay.hasClass('show')) {
				_overlay
					.addClass('hide');
			}

		})
		.on('click', function(event){
			_jsCurrentPopup
				.trigger('close');
			_jsOverlay
				.trigger('close');
		});

	$('.js-popup-open')
		.on('click', function(event){
			event.preventDefault();

			$(document.getElementById(this.getAttribute('data-popup')))
				.trigger('open');
		});

	$('.js-popup-team')
		.on('click', function(event){
			event.preventDefault();

			var _link = $(this),
				_overlayBox = $('#'+ _link.data('popup')),
				_overlayCloseBtn = _overlayBox.find('.close'),
				_templateContent = $('#'+ _link.attr('data-template-id')).html();

			_overlayBox
				.find('.popup-inner')
				.empty()
				.append(_templateContent)
				.trigger('open');

			var x = window.scrollX,
				y = window.scrollY;
			_overlayCloseBtn.attr('data-focus-back', _link.attr('id')).focus();
			window.scrollTo(x, y);
		});

	$('#overlay-team-member')
		.on('keydown', function(event) {
			var $this = $(this),
                $close = $this.find('.js-popup-close');

            if (event.keyCode == 27) { // esc
				$close.trigger('click');
			}

			if (event.keyCode == 9) { // tab or maj+tab
				event.preventDefault();

				var children = $this.find('*');
				var focusableItems = children.filter('a[href], button').filter(':visible');
                var focusedItem = $(document.activeElement);
                var numberOfFocusableItems = focusableItems.length;
				var focusedItemIndex = focusableItems.index(focusedItem);

                if (!event.shiftKey) {
					if (focusedItemIndex == numberOfFocusableItems - 1) {
						focusableItems.get(0).focus();
						return;
					}
					focusableItems.get(focusedItemIndex + 1).focus();
				}

                if (event.shiftKey) {
					if (focusedItemIndex == 0) {
						focusableItems.get(numberOfFocusableItems - 1).focus();
						return;
					}
					focusableItems.get(focusedItemIndex - 1).focus();
                }
			}
		});

	$('.js-team-popup-close')
		.on('click', function() {
			var $this = $(this),
				$focus_back = '#' + $this.attr('data-focus-back');

			$($focus_back).focus();
		});

	$('.js-popup-close')
		.on('click', function(event){
			event.preventDefault();

			_jsCurrentPopup
				.trigger('close');
			_jsOverlay
				.trigger('close');
		});

	$('[data-video]')
		.on('click', function(event){
			var iframe = document.querySelector('#overlay-video iframe');
			iframe.src = 'https://www.youtube.com/embed/'+this.getAttribute('data-video')+'?wmode=transparent';

			var _transcript = document.querySelector('#overlay-video .transcript .inner'),
				transcriptSrc = document.querySelector('[data-video-transcript="'+this.getAttribute('data-video')+'"]');

			if (transcriptSrc !== null) {
				_transcript.style.display = '';
				_transcript.innerHTML = transcriptSrc.innerHTML;
			} else {
				_transcript.style.display = 'none';
			}
		});

	$('.js-overlay-video')
		.on('close', function(){
			var iframe = document.querySelector('#overlay-video iframe'),
			_transcript = document.querySelector('#overlay-video .transcript .inner');

			iframe.src = '';
			_transcript.innerHTML = '';
		});

	$('.js-popup-open-parent')
		.on('click', '.js-popup-open', function(event){
			event.preventDefault();

			$(document.getElementById(this.getAttribute('data-popup')))
				.trigger('open');
		})
		.on('click', '[data-video]', function(event){
			var iframe = document.querySelector('#overlay-video iframe');
			iframe.src = 'https://www.youtube.com/embed/'+this.getAttribute('data-video')+'?wmode=transparent';

			var _transcript = document.querySelector('#overlay-video .transcript .inner'),
				transcriptSrc = document.querySelector('[data-video-transcript="'+this.getAttribute('data-video')+'"]');

			if (transcriptSrc !== null) {
				_transcript.style.display = '';
				_transcript.innerHTML = transcriptSrc.innerHTML;
			} else {
				_transcript.style.display = 'none';
			}
		})
		.find('.js-popup-open')
			.off('click');


	// -------
	// Gallery
	// -------
	const $glightboxCarousel = $('#glightbox-carousel');
	$glightboxCarousel.slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: true,
		arrows: true,
	});

	$glightboxCarousel.on('click', '.glightbox-trigger', function (e) {
		e.stopPropagation();
		e.preventDefault();

		const href = $(this).data('href');
		const title = $(this).data('title');
		import('glightbox').then(({ default: GLightbox }) => {
			const lightbox = GLightbox({
				elements: [{
					href,
					title,
					type: 'image'
				}],
				loop: true
			});
			lightbox.open();
		});
	});

	// ----
	// Maps
	// ----
	(function(){ // I LIKE HAVING SCOPE
		// Variables
		var map,
			mapOpts = {
				center: { lat: 0, lng: 0 },
				zoom: 8
			},
			bounds,
			infowindow,
			markers = [];

		var elMap = document.getElementById('articles-map'),
			elTabMap = document.getElementById('tab-link-map');

		if (!elMap) return;

		// Functions
		var removeMapTab = function(){
			var elContentMap = document.getElementById('tab-map'),
				elTabMap = document.getElementById('tab-link-map');

			elContentMap.parentNode.removeChild(elContentMap);
			elTabMap.parentNode.removeChild(elTabMap);
		};
		var setupMarkerEvent = function(marker){
			google.maps.event.addListener(marker, 'click', function(){
				infowindow.setContent('<div class="event-infowindow"><h2>'+marker.title+'</h2><div class="time">'+marker.date+'</div><a class="lnk-arrow" href="'+marker.link+'">View Event</a></div>');
				infowindow.open(map, marker);
			});
		};
		var init = function(){
			map = new google.maps.Map(elMap, mapOpts);
			bounds = new google.maps.LatLngBounds();
			infowindow = new google.maps.InfoWindow();

			for (var i = 0, len = events.length; i < len; i++) {
				if (events[i].lat !== 0 && events[i].lng !== 0) {
					var mkr = new google.maps.Marker({
						map: map,
						position: { lat: events[i].lat, lng: events[i].lng },
						title: events[i].title,
						date: events[i].date,
						link: events[i].link
					});

					bounds.extend(mkr.getPosition());

					setupMarkerEvent(mkr);

					markers.push(mkr);

					removeClass(elTabMap, 'hidden');
				}
			}

			if (markers.length === 0) {
				removeMapTab();
			}

			map.fitBounds(bounds);
		};

		google.maps.event.addDomListener(window, 'load', init);
	})();

	(function(){
		var q = _ad.qString(window.location.search),
			defaultDate = '';

		if (q && q.arc_day && q.arc_month && q.arc_year) {
			defaultDate = q.arc_day+'/'+q.arc_month+'/'+q.arc_year;
		}

		$(".js-diary-calendar")
			.datepicker({
				defaultDate: defaultDate,
				dateFormat: 'dd/mm/yy'
			})
			.val(defaultDate)
			.on('change', function(){
				var date = this.value.split('/');

				window.location = window.location.protocol +
					'//' +
					window.location.hostname +
					window.location.pathname +
					'?arc_day='+date[0]+'&arc_month='+date[1]+'&arc_year='+date[2];
			});
	})();


	// Grants //
	$('.grant-listing')
		.each(function(index, elGrantListing){
			var _items = $(elGrantListing).find('.grant-item p');
			_ad.checkHeight(_items);

			var _img = $(elGrantListing).find('.grant-item_image img'),
				_imgWrap = $(elGrantListing).find('.grant-item_image');

			_img.on('load', function(){
				_ad.checkHeight(_imgWrap);
			});
		});


	// -----------
	// Uploadifive
	// -----------
	var funcHandleOnSelect = function(){
		var _row = this.parents('.row');

		_row
			.next('.row').removeClass('hidden')
			.end()
			.find('.uploadifive-button').addClass('hidden')
			.end()
			.find('.uploadifive-queue').addClass('show');
	},
	funcHandleOnCancel = function(){
		var _row = this.parents('.row');

		_row
			.find('.uploadifive-button').removeClass('hidden')
			.end()
			.find('.uploadifive-queue').removeClass('show');
	};
	$('#application_one')
		.uploadifive({
			uploadScript: '/site/assets/api.php?controller=registration&action=upload',
			onSelect: funcHandleOnSelect,
			onCancel: funcHandleOnCancel,
			buttonText: 'Select file...',
			'onUploadComplete': function (file, data) {
				var obj = jQuery.parseJSON(data);
				$('#application_one_url').val(obj.filename);
			}
		});
	$('#application_two')
		.uploadifive({
			uploadScript: '/site/assets/api.php?controller=registration&action=upload',
			onSelect: funcHandleOnSelect,
			onCancel: funcHandleOnCancel,
			buttonText: 'Select file...',
			'onUploadComplete': function (file, data) {
				var obj = jQuery.parseJSON(data);
				$('#application_two_url').val(obj.filename);
			}
		});
	$('#application_three')
		.uploadifive({
			uploadScript: '/site/assets/api.php?controller=registration&action=upload',
			onSelect: funcHandleOnSelect,
			onCancel: funcHandleOnCancel,
			buttonText: 'Select file...',
			'onUploadComplete': function (file, data) {
				var obj = jQuery.parseJSON(data);
				$('#application_three_url').val(obj.filename);
			}
		});

	// ---------------
	// Events calendar
	// ---------------

	$('.events-calendar')
		.each(function(index, element){
			// Objects
			var _this = $(element),
				_inner = $(element.querySelector('.future-events')),
				_filters = element.querySelectorAll('.future-filters .js-filter'),
				_blocks = element.querySelectorAll('.future-events .event-block'),
				_pastInner = $(element.querySelector('.past-events')),
				_pastFilters = element.querySelectorAll('.past-filters .js-filter'),
				_pastBlocks = element.querySelectorAll('.past-events .event-block');

			$('.past-filters, .past-events, .toggle-future').hide();

			// Set up month heading blocks
			var months = {},
				years = {},
				pastmonths = {},
				pastyears = {};

			$(_blocks)
				.each(function(index, el){
					var month = el.getAttribute('data-month'),
						year = el.getAttribute('data-year');

					if (months[month] !== true) {
						var _monthEl = $('<a href="" class="event-block month" data-year="' + year + '" data-month="' + month + '"><span class="inner"><h2><span>' + month + '</span> ' + year + '</h2></span></a>');
						_monthEl.insertBefore(this);
					}
					months[month] = true;
					years[year] = true;
				});

			var elMonths = document.querySelectorAll('.future-events .month');
			for (var key in months) {
				var elMonth;
				for (var i = 0, len = elMonths.length; i < len; i++) {
					if (elMonths[i].getAttribute('data-month') === key) {
						elMonth = elMonths[i];
					}
				}
				if (!elMonth) return false;
			}

			$(_pastBlocks)
				.each(function(index, el){
					var month = el.getAttribute('data-month'),
						year = el.getAttribute('data-year');

					if (pastmonths[month] !== true) {
						var _monthEl = $('<a href="" class="event-block month" data-year="' + year + '" data-month="' + month + '"><span class="inner"><h2><span>' + month + '</span> ' + year + '</h2></span></a>');
						_monthEl.insertBefore(this);
					}
					pastmonths[month] = true;
					pastyears[year] = true;
				});

			var elPastMonths = document.querySelectorAll('.past-events .month');
			for (var key in pastmonths) {
				var elPastMonth;
				for (var i = 0, len = elPastMonths.length; i < len; i++) {
					if (elPastMonths[i].getAttribute('data-month') === key) {
						elPastMonth = elPastMonths[i];
					}
				}
				if (!elPastMonth) return false;
			}

			//Build Filters
			var _filterYear = $('.future-year-filter'),
				_filterMnth = $('.future-month-filter');
			for (var x in years) {
				var opt = $('<option>' + x + '</option>');
				_filterYear.append(opt);
			}
			for (var x in months) {
				var opt = $('<option>' + x + '</option>');
				_filterMnth.append(opt);
			}
			_filterYear.trigger('change');
			_filterMnth.trigger('change');

			var _filterPastYear = $('.past-year-filter'),
				_filterPastMnth = $('.past-month-filter');
			for (var x in pastyears) {
				var opt = $('<option>' + x + '</option>');
				_filterPastYear.append(opt);
			}
			for (var x in pastmonths) {
				var opt = $('<option>' + x + '</option>');
				_filterPastMnth.append(opt);
			}
			_filterPastYear.trigger('change');
			_filterPastMnth.trigger('change');

			// Functions
			var buildFilter = function(filters){
				var output = '';
				for (var i = 0; i < filters.length; i++) {
					if (filters[i].value !== '') {
						output += '[data-'+filters[i].name+'*='+filters[i].value+']'
					}
				}
				return output;
			};

			// Events
			$(_filters)
				.off().on('change', function(event) {
					var select = this;
					_inner.isotope({ filter: buildFilter(_filters) });
				});
			$(_pastFilters)
				.off().on('change', function(event) {
					var select = this;
					_pastInner.isotope({ filter: buildFilter(_pastFilters) });
				});
			$('.event-block.month')
				.off().on('click', function() {
					return false;
				});
			$('.toggle-past')
				.off().on('click', function() {
					$('.future-filters, .future-events, .toggle-past').hide();
					$('.past-filters, .past-events, .toggle-future').show();
					return false;
				});
			$('.toggle-future')
				.off().on('click', function() {
					$('.past-filters, .past-events, .toggle-future').hide();
					$('.future-filters, .future-events, .toggle-past').show();
					return false;
				});
		});


	// ---------
	// Plan 2017
	// ---------
	$('.plan')
		.each(function(index, elPlan){
			// Elements
			var elTimeFilter = elPlan.querySelector('.plan_filter_bytime'),
				elTimeFilterItems,
				elSubCats = elPlan.querySelectorAll('.plan_filter_bysubcat'),
				elSubCatsItems = elPlan.querySelectorAll('.plan_filter_bysubcat li'),
				elCatFilter = elPlan.querySelector('.plan_filter_bycategory'),
				elCats,
				elArticlesGroups = elPlan.querySelectorAll('.plan_articles_group');
				elArticles = elPlan.querySelectorAll('.plan_articles_article'),
				elArticleContent = elPlan.querySelector('.plan_articles_content');

			// Populate Elements
			if (elTimeFilter) elTimeFilterItems = elTimeFilter.querySelectorAll('button');
			if (elCatFilter) elCats = elCatFilter.querySelectorAll('li');

			//jQuery Objects
			var _articles = $(elArticles);

			// Variables
			var categoryFilter,
				subcatFilter,
				lastVisit = false,
				timeFilter = 'all',
				tmrHideSubCat = null;

			// Functions
			var funcHideSubcat = function(){
				tmrHideSubCat = setTimeout(function(){
					_ad.forEach(elSubCats, function(el){
						removeClass(el, 'plan_filter_bysubcat__show');
					});
				}, 500);
			};
			var funcCountObject = function(obj){
				var output = 0;
				for (key in obj) {
					output = output + 1;
				}
				return output;
			};
			var funcFilterTime = function(){
				var filterBtm = 0,
					filterTop = parseInt(moment().format('x')) / 1000;

				switch (timeFilter) {
					case 'latest':
						filterBtm = parseInt(moment().subtract(3, 'months').format('x')) / 1000;
					break;
					case 'visit':
						filterBtm = parseInt(moment(lastVisit, 'MM-DD-YYYY').format('x')) / 1000;
					break;
					default:
				}

				_ad.forEach(elArticles, function(el){
					var articleDate = parseInt(el.getAttribute('data-published'));
					if (articleDate > filterTop || articleDate < filterBtm) {
						addClass(el, 'plan_articles_article__outofdate');
					} else {
						removeClass(el, 'plan_articles_article__outofdate');
					}
				});
			};
			var funcFilterNEW = function(){
				// An alternate filtering method //
				var appliedFilters = [];

				if (elCats) {
					_ad.forEach(elCats, function(el){
						if (hasClass(el, 'plan_filter_bycategory__active')) {
							appliedFilters.push('.plan_articles_article[data-category="'+el.getAttribute('data-category')+'"]');
						}
					});
				}

				_ad.forEach(elSubCatsItems, function(el){
					if (hasClass(el, 'plan_filter_bysubcat__active')) {
						appliedFilters.push('.plan_articles_article[data-subcat="'+el.getAttribute('data-subcat')+'"]');
					}
				});

				if (appliedFilters.length < 1) {
					appliedFilters.push('.plan_articles_article');
				}

				_ad.forEach(elArticles, function(el){
					addClass(el, 'hidden');
				});

				_ad.forEach(appliedFilters, function(filter){
					var elFiltered = elPlan.querySelectorAll(filter);

					_ad.forEach(elFiltered, function(el){
						removeClass(el, 'hidden');
					});
				});

				_articles.removeClass('plan_articles_article__notactive');
				elArticleContent.innerHTML = '';

				return true;
			};
			var funcFilter = function(){
				// First setup the filter options //
				categoryFilter = {};
				if (elCats) {
					_ad.forEach(elCats, function(el){
						if (hasClass(el, 'plan_filter_bycategory__active')) {
							categoryFilter[el.getAttribute('data-category')] = true;
						}
					});
				}

				subcatFilter = {};
				subcatCats = {};
				_ad.forEach(elSubCatsItems, function(el){
					if (hasClass(el, 'plan_filter_bysubcat__active')) {
						subcatFilter[el.getAttribute('data-subcat')] = true;
						subcatCats[el.parentNode.getAttribute('data-category')] = true;
					}
				});


				// Second use those filters //
				if (funcCountObject(categoryFilter) > 0) {
					_ad.forEach(elArticlesGroups, function(el){
						addClass(el, 'hidden');
					});

					for (cfKey in categoryFilter) {
						var elItems = elPlan.querySelectorAll('.plan_articles_group[data-category="'+cfKey+'"]');
						_ad.forEach(elItems, function(el){
							removeClass(el, 'hidden');
						});
					}
				} else {
					if (elCats) {
						_ad.forEach(elArticlesGroups, function(el){
							addClass(el, 'hidden');
						});
					}
				}

				_ad.forEach(elArticles, function(el){
					removeClass(el, 'hidden');
				});

				if (funcCountObject(subcatFilter) > 0) {
					for (sccKey in subcatCats) {
						var elItems = elPlan.querySelectorAll('.plan_articles_group[data-category="'+sccKey+'"] .plan_articles_article');
						_ad.forEach(elItems, function(el){
							addClass(el, 'hidden');
						});
					}

					for (scfKey in subcatFilter) {
						var elItems = elPlan.querySelectorAll('.plan_articles_article[data-subcat="'+scfKey+'"]');
						_ad.forEach(elItems, function(el){
							removeClass(el, 'hidden');
						});
					}
				}

				_articles.removeClass('plan_articles_article__notactive');
				elArticleContent.innerHTML = '';

				return true;
			};

			$(elCatFilter)
				.on('mouseover', 'li', function(){
					if (tmrHideSubCat) {
						clearTimeout(tmrHideSubCat);
					}
					var cat = this.getAttribute('data-category');

					_ad.forEach(elSubCats, function(el){
						removeClass(el, 'plan_filter_bysubcat__show');

						if (cat === el.getAttribute('data-category')) {
							addClass(el, 'plan_filter_bysubcat__show');
						}
					});
				})
				.on('mouseout', funcHideSubcat)
				.on('click', 'button', function(event) {
					event.preventDefault();

					var elParent = this.parentNode,
						$allTabLinks = $(this).closest('.plan_filter_bycategory').find('li button'),
						$allControlPanels = $(this).closest('.plan').find('.plan_articles_group'),
						elControlPanel,
						elSubCats;

					if (!hasClass(elParent, 'plan_filter_bycategory__active')) {
						elSubCats = elPlan.querySelectorAll('.plan_filter_bysubcat[data-category="'+elParent.getAttribute('data-category')+'"] li');
						_ad.forEach(elSubCats, function(el){
							removeClass(el, 'plan_filter_bysubcat__active');
						});
					}

					_ad.forEach(elCats, function(el) {
						removeClass(el, 'plan_filter_bycategory__active');
						$allTabLinks.attr({ 'tabindex': -1, 'aria-selected': 'false' });
						$allControlPanels.attr('aria-hidden', 'true');
						if (el === elParent) {
							addClass(el, 'plan_filter_bycategory__active');
						}
					});

					this.setAttribute('aria-selected', true);
					this.setAttribute('tabindex', 0);
					elControlPanel = elPlan.querySelector('#' + this.getAttribute('aria-controls'));
					elControlPanel.removeAttribute('aria-hidden');

					funcFilter();
				})
				.on('keydown', function(event) {
					var $activated = $(this).find('li button[aria-selected="true"]').parent(),
						$last_link = $(this).find('li:last-child button'),
						$first_link = $(this).find('li:first-child button'),
						$prev = $activated,
						$next = $activated;

					// search valid previous
					do {
						if ($prev.is('li:first-child')) {
							$prev = $last_link.parent();
						} else {
							$prev = $prev.prev();
						}
					} while ($prev.children('button').attr('aria-disabled') === 'true' && $prev !== $activated);

					// search valid next
					do {
						if ($next.is('li:last-child')) {
							$next = $first_link.parent();
						} else {
							$next = $next.next();
						}
					} while ($next.children('button').attr('aria-disabled') === 'true' && $next !== $activated);

					// catch keyboard event only if focus is on tab
					if (!event.ctrlKey) {
						if (event.keyCode == 37 || event.keyCode == 38) { // strike up or left in the tab
							event.preventDefault();
							$prev.children('button').click().focus();
						} else if (event.keyCode == 40 || event.keyCode == 39) { // strike down or right in the tab
							event.preventDefault();
							$next.children('button').click().focus();
						} else if (event.keyCode == 36) { // activate first tab
							event.preventDefault();
							$first_link.click().focus();
						} else if (event.keyCode == 35) { // activate last tab
							event.preventDefault();
							$last_link.click().focus();
						}

					}
				});

			$(elSubCats)
				.on('mouseover', function(){
					if (tmrHideSubCat) {
						clearTimeout(tmrHideSubCat);
					}
				})
				.on('mouseout', funcHideSubcat)
				.on('click', 'button', function(){
					// Elements
					var elParent = this.parentNode,
						elCat;

					// Variables
					var cat = elParent.parentNode.getAttribute('data-category');

					toggleClass(elParent, 'plan_filter_bysubcat__active');

					if (elCatFilter) {
						elCat = elCatFilter.querySelector('[data-category="'+cat+'"]');

						if (hasClass(elParent, 'plan_filter_bysubcat__active')) {
							// If the subcategory has been toggled on force the parent category on as well //
							addClass(elCat, 'plan_filter_bycategory__active');
						}
					}

					funcFilter();
				});

			$(elTimeFilter)
				.on('click', 'button', function(){
					_ad.forEach(elTimeFilterItems, function(el){
						removeClass(el, 'plan_filter_bytime__active');
					});
					addClass(this, 'plan_filter_bytime__active');
					timeFilter = this.value;
					funcFilterTime();
				});

			_articles
				.on('click', function(event){
					event.preventDefault();
					var elThis = this,
						elSiblings = this.parentNode.querySelectorAll('.plan_articles_article'),
						elContent = this.querySelector('.plan_articles_article_content'),
						elInsertAfter;

					toggleClass(this, 'plan_articles_article__active');

					if (hasClass(this, 'plan_articles_article__active')) {
						// Show the content for this article
						elArticleContent.innerHTML = elContent.innerHTML;

						// Setup the inactive classes for the other articles
						_articles.addClass('plan_articles_article__notactive');
						removeClass(this, 'plan_articles_article__notactive');

						// Move the article content div to the line below the selected article
						var thisTop = elThis.offsetTop;

						for (var i = 0, l = elSiblings.length; i < l; i++) {
							var el = elSiblings[i];
							if (el.offsetTop > thisTop) {
								elInsertAfter = elSiblings[i-1];
								break;
							}
						}

						if (!elInsertAfter) {
							elInsertAfter = elSiblings[elSiblings.length-1];
						}

						$(elInsertAfter).after(elArticleContent);
					} else {
						// Turn this article off
						elArticleContent.innerHTML = '';

						// Remove the inactive class from all articles
						_articles.removeClass('plan_articles_article__notactive');
					}
				});

			// Setup the last visited tab if required //
			lastVisit = readCookie('lastvisit');

			if (lastVisit !== false) {
				var lastVisitDate = moment(lastVisit, 'MM-DD-YYYY'),
					lastVisitTimestamp = parseInt(lastVisitDate.format('x')) / 1000,
					lastVisitUpdates = false;

				_ad.forEach(elArticles, function(el){
					var publishDate = parseInt(el.getAttribute('data-published'));
					if (publishDate > lastVisitTimestamp) {
						lastVisitUpdates = true;
						return 'break';
					}
				});

				if (lastVisitUpdates) {
					removeClass(document.querySelector('.plan_filter_bytime_previous'), 'hidden');
				}
			}

			// Set the lastvisit cookie to the current date
			// createCookie('lastvisit', moment('04-17-2017', 'MM-DD-YYYY').format('MM-DD-YYYY'), 365); // Test cookie
			createCookie('lastvisit', moment().format('MM-DD-YYYY'), 365);
		});


	// ---------
	// Polyfills
	// ---------
	_window
		.on('load', function(){
			// Reflow after doc has loaded //
			_ad.checkHeight($('.tabs .tabs-links a'), false, false);
		});

	var serialize = function(obj, prefix) {
		var str = [];
		for(var p in obj) {
			var k = prefix ? prefix + "[" + p + "]" : p, v = obj[p];
			str.push(typeof v == "object" ?
				serialize(v, k) :
				encodeURIComponent(k) + "=" + encodeURIComponent(v));
		}
		return str.join("&");
	}

    // ---------
	// Skipping
    // ---------
    $('.js-screen-reader').each(function(idx, el) {
        $(this).on('click', function(e) {
            e.preventDefault();

			if ($(this).attr('id') === 'tomain') {
				$('.header-site').next().find('a').eq(0).focus();
			} else if ($(this).attr('id') === 'tomenu') {
                if (window.matchMedia('(min-width: 768px)').matches) {
                    $('.nav-main').find('a').eq(0).focus();
                } else {
                    $('.header-site .left').focus();
                }
            }

            var $parent = $(this).parent();
            setTimeout(function() {
                if ($parent.hasClass('skip-section') && $parent.hasClass('show') && $parent.find('a:focus').length == 0) {
                    $parent.removeClass('show');
                }
            }, 1);
        })

        $(this).on('focus', function(e) {
            e.preventDefault();

            var $parent = $(this).parent();
            if ($parent.hasClass('skip-section')) {
                $parent.addClass('show');
            }
        });

        $(this).on('blur', function(e) {
            e.preventDefault();

            var $parent = $(this).parent();
            setTimeout(function() {
                if ($parent.hasClass('skip-section') && $parent.hasClass('show') && $parent.find('a:focus').length == 0) {
                    $parent.removeClass('show');
                }
            }, 1);
        });
    });
});